import React, { useEffect } from "react";
import "./CartDrawer.css";
import { FaRegTrashCan } from "react-icons/fa6";
import { MdAdd } from "react-icons/md";
import { FiMinus } from "react-icons/fi";
import { GiShoppingCart } from "react-icons/gi";
import { FaLongArrowAltRight } from "react-icons/fa";
import NoImage from "../../assets/no-track.avif";

export default function CartDrawer({
  isOpen,
  onClose,
  items = [],
  onRemoveItem,
  onIncreaseQty,
  onDecreaseQty,
  onViewCart,
  onCheckout,
  onContinueShopping,
}) {
  // close on ESC
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) =>
      e.key === "Escape" && onClose?.();

    window.addEventListener("keydown", onKeyDown);

    return () =>
      window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  // lock body scroll when open
  useEffect(() => {
    if (!isOpen) return;

    const prev = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => (document.body.style.overflow = prev);
  }, [isOpen]);

  const subtotal = items.reduce(
    (sum, it) =>
      sum + (it.price || 0) * (it.qty || 1),
    0,
  );

  const totalQty = items.reduce(
    (sum, item) =>
      sum + (item.qty ?? 1),
    0
  );

  const handleCheckoutClick = () => {
    if (items.length === 0) {
      alert("Your cart is empty 🛒");
      return;
    }

    onCheckout?.();
    onClose?.();
  };

  const handleViewCartClick = () => {
    onViewCart?.();
    onClose?.();
  };

  const handleContinueShoppingClick = () => {
    onContinueShopping?.();
    onClose?.();
  };

  return (
    <>
      <div
        className={`cartOverlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />

      <aside
        className={`cartDrawer ${isOpen ? "open" : ""}`}
        aria-hidden={!isOpen}
      >
        <div className="cartHeader">
          <div className="cartTitle">
            <span className="cartBag">
              <GiShoppingCart size={28} />

              {items.length > 0 && (
                <span className="cartBadge">
                  {totalQty}
                </span>
              )}
            </span>

            <h3>Your Cart</h3>
          </div>

          <button
            type="button"
            className="cartClose"
            onClick={onClose}
            aria-label="Close cart"
          >
            ×
          </button>
        </div>

        <div className="cartBody">
          {items.length === 0 ? (
            <div className="cartEmpty">
              <p>Your cart is empty.</p>

              <button
                type="button"
                className="cartBtn outline"
                onClick={handleContinueShoppingClick}
              >
                Continue Shopping
              </button>
            </div>
          ) : (
            <div className="cartItems">
              {items.map((it) => (
                <div
                  className="cartItem px-2"
                  key={it.id}
                >
                  <img
                    src={
                      !it.image ||
                        it.image.trim().toLowerCase() === "n/a"
                        ? NoImage
                        : `${it.image}`
                    }
                    alt={it.titleEn}
                    loading="lazy"
                    fetchPriority="high"
                    decoding="async"
                    className="cartItemImg"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = NoImage;
                    }}
                  />

                  {/* <img className="cartItemImg" src={it.image} alt={it.title} /> */}

                  <div className="cartItemInfo">
                    <div className="cartItemTop">
                      <div>
                        <div className="cartItemTitle">
                          {it.title}
                        </div>

                        {/* <div className="cartItemMeta">Qty: {it.qty}</div> */}

                        <div className="cartItemMeta">
                          Price: ${Number(it.price).toFixed(2)}
                        </div>
                      </div>

                      <div className="cart-qty">
                        <button
                          type="button"
                          className="cartTrash"
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveItem?.(it.id);
                          }}
                          aria-label="Remove item"
                          title="Remove"
                        >
                          <FaRegTrashCan size={17} />
                        </button>

                        <button
                          type="button"
                          className="cartTrash"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDecreaseQty?.(it.id);
                          }}
                          aria-label="Decrease quantity"
                        >
                          <FiMinus size={20} />
                        </button>

                        <div className="cartItemMeta1 px-2">
                          {it.qty}
                        </div>

                        <button
                          type="button"
                          className="cartTrash"
                          onClick={(e) => {
                            e.stopPropagation();
                            onIncreaseQty?.(it.id);
                          }}
                          aria-label="Increase quantity"
                        >
                          <MdAdd size={20} />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <div className="cartItemTotal">
                    ${(Number(it.price) * Number(it.qty)).toFixed(2)}
                  </div> */}
                </div>
              ))}
            </div>
          )}
        </div>

        {items.length > 0 && (
          <div className="cartFooter">
            <div className="cartSubtotalRow">
              <span className="cartSubtotalLabel">
                Subtotal:
              </span>

              <span className="cartSubtotalValue">
                ${subtotal.toFixed(2)}
              </span>
            </div>

            <p className="cartHint">
              Shipping, taxes, and discounts calculated at checkout.
            </p>

            {/* <button className="cartBtn" onClick={onViewCart}>
              View Cart
            </button> */}

            <div className="d-flex flex-column">
              <button
                type="button"
                onClick={handleViewCartClick}
                className="cart-view-btn mb-2"
              >
                <div className="cart-view-final">
                  <span className="cart-view">
                    View Cart
                  </span>

                  <span className="arrow">
                    <FaLongArrowAltRight size={20} />
                  </span>
                </div>
              </button>

              <button
                type="button"
                onClick={handleContinueShoppingClick}
                className="cart-view-btn mb-2"
              >
                <div className="cart-view-final">
                  <span className="cart-view">
                    Continue Shopping
                  </span>

                  <span className="arrow">
                    <FaLongArrowAltRight size={20} />
                  </span>
                </div>
              </button>

              <button
                type="button"
                onClick={handleCheckoutClick}
                className="cart-view-btn"
              >
                <div className="cart-view-final">
                  <span className="cart-view">
                    Checkout - ${subtotal.toFixed(2)}
                  </span>

                  <span className="arrow">
                    <FaLongArrowAltRight size={20} />
                  </span>
                </div>
              </button>
            </div>

            {/* <button className="cartBtn outline" onClick={onContinueShopping}>
              Continue Shopping
            </button> */}

            {/* <button className="cartBtn" onClick={onCheckout}> */}
            {/* Checkout - ${(subtotal * 1.2025).toFixed(2)} */}
            {/* Checkout - ${subtotal.toFixed(2)}
            </button> */}
          </div>
        )}
      </aside>
    </>
  );
}